import { ArrowRightLeft } from 'lucide-react';
import { formatDateTime } from '@/lib/format.js';

export function TicketTransferBanner({
  originalStoreName,
  transferredAt,
}: {
  originalStoreName?: string | null;
  transferredAt?: string | null;
}) {
  if (!originalStoreName) return null;

  return (
    <div className="flex items-start gap-3 rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900">
      <ArrowRightLeft className="mt-0.5 h-4 w-4 shrink-0" />
      <div>
        <p className="font-semibold">Transferred from another store</p>
        <p className="mt-0.5 text-blue-800">
          Originally opened at <strong>{originalStoreName}</strong>
          {transferredAt ? ` · Transferred ${formatDateTime(transferredAt)}` : null}
        </p>
      </div>
    </div>
  );
}
